import { controls } from "../controls";


const tr046 = {
  label: "Import File for Transaction",
  pageLabel: "Import File for Transaction",
  starting: true,
  url: "tr046",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display" }),
    ...controls.checkBox({ tab: "filter", default: true, label: "Process", name: "isProcess", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4" }),

    ...controls.magicDateLabel({ tab: "filter", star: true, label: "As On Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "as_on_date", width: "col-sm-2", default: "sessiondate" }),


    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    ...controls.displayText({ tab: "filter", label: "File Type", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-10" }),
    ...controls.displayText({ tab: "filter", label: "File Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", placeHolder: "File Name", name: "file_name", width: "col-sm-2" }),
    {
      inputType: "fileupload",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      readFile: { targetTable: 'sample_table', type: 'csv', columns: ['name', 'age', 'pin'] },
      label: "Fileupload",
      name: "file_read",
      placeholder: {
        type: "text",
        value: "Upload Sign."
      },
      files: [],
      multiple: true
    },
    {
      inputType: "table",
      tableTitle: "",
      // convertedTo: "nominee_table",
      deletable: true,
      isRequired: true,
      // editable: true,
      // addRows: true,
      tableHeaders: [
        { label: "Name", field: "name" },
        { label: "Age", field: "age" },
        { label: "Pin", field: "pin" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "sample_table"
    },


  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Srno",
        accessor: "srno",
        width: 150
      },
      {
        Header: "Account Number",
        accessor: "account_no",
        width: 150
      },
      {
        Header: "CIN",
        accessor: "cin",
        width: 150
      },
      {
        Header: "Name",
        accessor: "full_name",
        width: 150
      },

      {
        Header: "Int Flag",
        accessor: "int_flag",
        width: 150
      },
      {
        Header: "Balance",
        accessor: "balance",
        width: 150
      },
      {
        Header: "Balance",
        accessor: "balance",
        width: 150
      },
      {
        Header: "Credit",
        accessor: "credit",
        width: 150
      },
      {
        Header: "Debit",
        accessor: "debit",
        width: 150
      },
      {
        Header: "Int Date",
        accessor: "int_date",
        width: 150
      },
      {
        Header: "Int Rate",
        accessor: "int_rate",
        width: 150
      },



    ]
  }
}
export default tr046